module.exports = __webpack_public_path__ + "img/07.a23339c6.jpg";